import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container align-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "h3 m-4 text-center container" }, "Registration Interface", -1)
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 col-sm-1 text-right" }, " UserName ", -1)
const _hoisted_5 = { class: "col-6 col-sm-2 text-left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "row text-danger justify-content-center m-2" }, " (emails only) ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "row justify-content-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 col-sm-1 text-right" }, " Password ", -1)
const _hoisted_10 = { class: "col-6 col-sm-2 text-left" }
const _hoisted_11 = { class: "row justify-content-center" }
const _hoisted_12 = { class: "col-6 col-sm-3 m-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { id: "validateNotRobot" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "row justify-content-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "container" }
const _hoisted_19 = { class: "text-danger col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userName) = $event)),
          placeholder: "Enter Your Email Address"
        }, null, 512), [
          [_vModelText, $setup.userName]
        ])
      ])
    ]),
    _hoisted_6,
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
          placeholder: "Create Account Password"
        }, null, 512), [
          [_vModelText, $setup.password]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _withDirectives(_createElementVNode("div", _hoisted_12, _hoisted_15, 512), [
        [_vShow, $setup.isValidateNotRobotShown]
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _withDirectives(_createElementVNode("button", {
        class: _normalizeClass(["col-sm-1 col-4 btn btn-primary m-4", {'disabled':$setup.isBtnCreateUserLoginDisabled, 'btn-grey':$setup.isBtnCreateUserLoginDisabled}]),
        id: "btnCreateUserLogin",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.createUserLogin && $setup.createUserLogin(...args)))
      }, "Create User", 2), [
        [_vShow, $setup.isBtnCreateUserLoginShown]
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("span", _hoisted_19, _toDisplayString($setup.registrationStatus), 1)
    ])
  ]))
}